import { Pipe, PipeTransform } from '@angular/core';
import { Role } from '../interfaces/user';

@Pipe({
  name: 'userRole'
})
export class UserRolePipe implements PipeTransform {
  transform(role: Role | string): string {
    switch (role) {
      case Role.SUPER_ADMINISTRATOR: return 'Super Administrator';
      case Role.SERVICE_PROVIDER: return 'Service Provider';
      case Role.CLIENT: return 'Client';
      default: return role || '—';
    }
  }
}
